export default __webpack_public_path__ + "static/media/Nerd_DJFID.0b31c5cf.png";